export * from './lib/animal-selection-translations.module';
